import React from "react"
import styled from "styled-components"
import { up } from "styled-breakpoints"
import colors from "@constants/colors"
import { body, bodyBold, smallcaps } from "@constants/typography"
import { MobileOnly, LaptopUpOnly } from "@utils/MediaQueries"

const Container = styled.div`
  display: flex;
  align-items: center;
`

const Count = styled.div`
  display: initial;
  ${smallcaps}
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  margin-right: 18px;
  background-color: ${colors.obsidian};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.snow};
`

const Optional = styled.div`
  ${body}
  flex-shrink: 0;
  color: ${colors.obsidian};
  margin-left: 8px;
`
const OptionName = styled.div`
  ${bodyBold}
  flex-shrink: 0;
  color: ${colors.obsidian};
`

const OptionValue = styled.div`
  ${body}
  margin-left: 20px;
  color: ${colors.slateDark};
`

const OptionWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`

interface OptionHeaderProps {
  count: number
  optional?: boolean
  optionName: string
  optionValue: string
  onClick?: (e) => void
}

const OptionHeader: React.FC<OptionHeaderProps> = ({
  count,
  optional = false,
  optionName,
  optionValue,
  onClick = () => {},
}) => {
  return (
    <>
      <MobileOnly onClick={onClick}>
        <Container>
          {count ? <Count>{count}</Count> : ""}
          <OptionWrapper>
            <OptionName>{optionName} :</OptionName>
            {optional ? <Optional>(Optional)</Optional> : ""}
            <OptionValue>
              {optionValue ? optionValue : "-- Select --"}
            </OptionValue>
          </OptionWrapper>
        </Container>
      </MobileOnly>
      <LaptopUpOnly onClick={onClick}>
        <Container>
          {count ? <Count>{count}</Count> : ""}
          <OptionWrapper>
            <OptionName>{optionName}</OptionName>
            {optional ? <Optional>(Optional)</Optional> : ""}
            <OptionName>{optionValue ? ":" : ""}</OptionName>
            <OptionValue>{optionValue}</OptionValue>
          </OptionWrapper>
        </Container>
      </LaptopUpOnly>
    </>
  )
}

export default OptionHeader
